import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule } from '../layout/layout.module';
import { MediaObjectContentComponent } from './media-object-content.component';
import { MediaObjectThumbnailComponent } from './media-object-thumbnail.component';
import { MediaObjectComponent } from './media-object.component';

@NgModule({
  imports: [CommonModule, LayoutModule],
  declarations: [
    MediaObjectComponent,
    MediaObjectThumbnailComponent,
    MediaObjectContentComponent,
  ],
  exports: [
    MediaObjectComponent,
    MediaObjectThumbnailComponent,
    MediaObjectContentComponent,
  ],
})
export class MediaObjectModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/ui/media-object/media-object.module.ts